import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { ApiTravelHelperService } from './travel-helper.service';

@Injectable({ providedIn: 'root' })
export class ApiTravelService {
  constructor(
    public hpr: ApiTravelHelperService,
    private _api: ApiService,
  ) {}

  get(id: number | string) {
    return this._api.get('travel/get/id/' + id);
  }

  duplicate(id: number | string) {
    return this._api.get('travel/duplicate/id/' + id);
  }

  duplicateMembers(id: number | string) {
    return this._api.get('travel/duplicate-members/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('travel/list', data);
  }

  create(data: any) {
    return this._api.post('travel/create', data);
  }

  update(data: any) {
    return this._api.post('travel/update', data);
  }

  remove(id: number) {
    return this._api.post('travel/remove/id/' + id);
  }

  sendActiveOrganizerMail(data: any = {}) {
    return this._api.post('travel/send-active-organizer-mail', data);
  }

  acceptAll(id: number) {
    return this._api.post('travel/accept-all/id/' + id);
  }

  sendMessage(data: any) {
    return this._api.post('travel/send-message', data);
  }

  pull(data: any) {
    return this._api.post('travel/pull', data, { edge: true });
  }

  weather(id: number | string) {
    return this._api.get('travel/weather/id/' + id);
  }

  addUser(data: any) {
    return this._api.post('travel/add-user', data);
  }

  addOrganizer(data: any) {
    return this._api.post('travel/add-organizer', data);
  }

  updateUser(data: any) {
    return this._api.post('travel/update-user', data);
  }

  removeUser(data: any) {
    return this._api.post('travel/remove-user', data);
  }

  listMessages(data: any) {
    return this._api.post('travel/list-messages', data);
  }

  importMembers(data: any) {
    return this._api.post('travel/import-members', data);
  }

  importMedias(data: any) {
    return this._api.post('travel/import-medias', data);
  }

  sendSms(data: any) {
    return this._api.post('travel/send-sms', data);
  }

  sendMail(data: any) {
    return this._api.post('travel/send-mail', data);
  }
}
